<template>
    <div class="edu-frame">
        <edu-nav-bar title="修改密码" :show="show" @showPopup="show=true" @hidePopup="show=false"></edu-nav-bar>
        <div class="content-frame">
            <div class="edu-group" style="margin: 20px auto;">
                <div class="step-tips">请修改密码</div>
                <div class="class-form">
                    <van-field v-model="formData.oldPassword" type="password" required label="原密码" placeholder="请输入原密码" clearable/>
                    <van-field v-model="formData.password" type="password" required label="新密码" placeholder="请输入新密码" clearable/>
                    <van-field v-model="formData.rePassword" type="password" required label="重复新密码" placeholder="重复输入新密码" clearable/>
                </div>
            </div>
        </div>
        <!-- 保存按钮 -->
        <div class="bottom-frame">
            <van-button :loading="submitting" square block type="primary" @click="submit">保存</van-button>
        </div>
        <!-- 保存按钮 -->
    </div>
</template>
<script>
    import {Button, Field} from "vant";
    import EduNavBar from "@/components/EduNavBar";
    import Tools from "@/api/Tools";
    import CustomerApi from "@/api/CustomerApi";
    export default {
        components: {
            EduNavBar,
            VanButton: Button,
            VanField: Field
        },
        data() {
            return {
                show: false,
                formData: { },
                submitting: false,
                customer: Tools.getCurCust()
            }
        },
        methods: {
            submit() {
                // 提交修改的资料
                this.formData.custId = this.customer.custId
                if (this.formData.oldPassword == null || this.formData.oldPassword == '') {
                    this.$dialog.alert({ message: '请输入原密码' })
                    return
                }
                if (this.formData.password == null || this.formData.password == '') {
                    this.$dialog.alert({ message: '请输入新密码' })
                    return
                }
                if (this.formData.password != this.formData.rePassword) {
                    this.$dialog.alert({ message: '新密码两次输入不一致' })
                    return
                }
                this.submitting = true
                CustomerApi.modifyPassword(this.formData).then(response => {
                    this.submitting = false
                    // console.log(response)
                    this.$toast({message: response.msg});
                    if (response.code==100) {
                        this.$router.back()
                    }
                    /* if (response.code==100) {
                        this.$toast({message: response.msg});
                        Tools.setCurCust(response.res)
                        // 如果是从登陆中补完资料进入 需要再判断是否有空字段，如果有，则保留在此页，否则跳到主页
                        if (this.$route.query.hideBack == 1) {
                            CustomerApi.checkHasBlankField(response.res.custId).then(resp=>{
                                if (resp.res == 0) {
                                    this.$router.replace({ name: 'main' })
                                }
                            })
                        }
                    } */
                }).catch(() => { this.submitting = false })
            }
        },
        created() {
        }
    }
</script>
<style scoped>
    .photo-frame {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin: 15px auto;
    }
    .photo {
        width: 35%;
    }
    .photo-tips {
        color: red;
        font-size: 14px;
        margin-top: 5px;
    }
</style>
